import React, { memo } from 'react';
import { Flame as FlameIcon, Brain as BrainIcon, Zap as ZapIcon, Activity as ActivityIcon } from 'lucide-react';
import { trackLeadEvent } from './MetaPixel';
const Benefits = () => {
  const handleCTAClick = () => {
    trackLeadEvent('benefits_section_cta');
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  return <section id="benefits" className="py-14 md:py-20 bg-gradient-to-b from-white to-[#f8f9ff]" data-id="element-23">
      <div className="container mx-auto px-4 md:px-6" data-id="element-24">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#1e293b]" data-id="element-26">
            Sistema de Ataque en 4 Frentes
          </h2>
          <p className="text-xl text-[#4a5568]" data-id="element-27">
            Actúa sobre los 4 puntos críticos que perpetúan tus migrañas
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-28">
          <div className="bg-[#f8f9ff] p-8 rounded-xl shadow-md transition-all hover:shadow-lg hover:transform hover:scale-105" data-id="element-29">
            <div className="w-14 h-14 bg-[#eef2ff] rounded-full flex items-center justify-center mb-4" data-id="element-30">
              <FlameIcon size={28} className="text-[#6366f1]" data-id="element-31" />
            </div>
            <h3 className="text-xl font-semibold mb-2 text-[#1e293b]" data-id="element-32">
              Inflamación profunda
            </h3>
            <p className="text-[#4a5568]" data-id="element-33">Ataca la causa raíz del dolor</p>
          </div>
          <div className="bg-[#f8f9ff] p-8 rounded-xl shadow-md transition-all hover:shadow-lg hover:transform hover:scale-105" data-id="element-34">
            <div className="w-14 h-14 bg-[#eef2ff] rounded-full flex items-center justify-center mb-4" data-id="element-35">
              <BrainIcon size={28} className="text-[#6366f1]" data-id="element-36" />
            </div>
            <h3 className="text-xl font-semibold mb-2 text-[#1e293b]" data-id="element-37">
              Tensiones neuromusculares
            </h3>
            <p className="text-[#4a5568]" data-id="element-38">Relaja las áreas afectadas</p>
          </div>
          <div className="bg-[#f8f9ff] p-8 rounded-xl shadow-md transition-all hover:shadow-lg hover:transform hover:scale-105" data-id="element-39">
            <div className="w-14 h-14 bg-[#eef2ff] rounded-full flex items-center justify-center mb-4" data-id="element-40">
              <ZapIcon size={28} className="text-[#6366f1]" data-id="element-41" />
            </div>
            <h3 className="text-xl font-semibold mb-2 text-[#1e293b]" data-id="element-42">
              Estrés cerebral acumulado
            </h3>
            <p className="text-[#4a5568]" data-id="element-43">Reduce la presión craneal</p>
          </div>
          <div className="bg-[#f8f9ff] p-8 rounded-xl shadow-md transition-all hover:shadow-lg hover:transform hover:scale-105" data-id="element-44">
            <div className="w-14 h-14 bg-[#eef2ff] rounded-full flex items-center justify-center mb-4" data-id="element-45">
              <ActivityIcon size={28} className="text-[#6366f1]" data-id="element-46" />
            </div>
            <h3 className="text-xl font-semibold mb-2 text-[#1e293b]" data-id="element-47">
              Fatiga del sistema nervioso
            </h3>
            <p className="text-[#4a5568]" data-id="element-48">Restaura el equilibrio natural</p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-49">
          <p className="text-lg text-[#4a5568] italic" data-id="element-50">
            🔹 No es solo alivio. Es recuperación real.
          </p>
          <div className="mt-6" data-id="element-51">
            <button className="bg-[#4ade80] hover:bg-[#22c55e] text-white px-8 py-4 rounded-full text-lg font-medium transition-all transform hover:scale-105 shadow-lg" onClick={handleCTAClick} data-id="element-52">
              Empieza tu rutina de alivio hoy
            </button>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(Benefits);